/**
 * @generated SignedSource<<ec03a34e3b71e8016820431d98d456d9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useShouldBlockStorageUploads$data = {
  readonly attachmentStorageAllowed: AGG$Long | null | undefined;
  readonly attachmentStorageIsUnlimited: boolean | null | undefined;
  readonly attachmentStorageUsed: AGG$Long | null | undefined;
  readonly " $fragmentType": "useShouldBlockStorageUploads";
};
export type useShouldBlockStorageUploads$key = {
  readonly " $data"?: useShouldBlockStorageUploads$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldBlockStorageUploads">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useShouldBlockStorageUploads"
};

(node as any).hash = "9bc64763f1f956f91938ec154b1c67db";

export default node;
